import { Coords } from 'src/app/swagger-api';
import { Label } from '../../map.interfaces';
import { CustomMarkerBuilder } from './custom-marker.builder';

export class CovidMarkerBuilder extends CustomMarkerBuilder {
  public setInfoLabels(labels: Label[]): void {
    this.marker.infoLabels = labels;
  }

  public setRadius(radius: number): void {
    this.marker.radius = radius;
  }

  protected getMarkerId(coords: Coords): string {
    return `${coords.lat}_${coords.lon}`;
  }
}
